// 引入svg icon
import "virtual:svg-icons-register";

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.config.globalProperties.ossPath = "https://resource.auditoryworks.co/nearhub-v1";
});
